import { styled, Box, Grid } from "@mui/material";

export const StyledPopoverWrapper = styled(Box)({
  zIndex: 1000,
}) as typeof Box;

export const StyledGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  margin: theme.spacing(2, 0),
})) as typeof Grid;
